import { useEffect, useState } from "react";
import { formatMonthDate, getStartEndOfCurrentMonth } from "../../helper";
import { useGetRevenueStoreApi } from "../../hooks";
import {
  useAccountStore,
  useAuthStore,
  useCommonStore,
  useRevenueStore,
} from "../../store";
import {
  CardItemRevenueStore,
  FooterFilterMobile,
  LoaderCustom,
} from "../../components";
import { ScheduleOutlined } from "@ant-design/icons";
import { RangeCalendar } from "@nextui-org/react";
import useDebounce from "../../hooks/common/useDebounce";
import { emptyIcon, searchIcon } from "../../assets";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";

const RevenueStoreUserPage = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchQueryGroupName, setSearchQueryGroupName] = useState<string>("");
  const [filteredData, setFilteredData] = useState<any>([]);

  const debouceSearchQuery = useDebounce(searchQuery, 300);
  const debouceSearchQueryGroupName = useDebounce(searchQueryGroupName, 300);

  const { revenueStore, isLoading } = useGetRevenueStoreApi();
  const [isShowCalender, setIsShowCalender] = useState(false);

  const { info } = useAccountStore();

  const { setOpenSort } = useCommonStore();

  const { token } = useAuthStore();
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);

  const {
    setAccountId,
    setEndDate,
    setStartDate,
    startDate,
    endDate,
    setRevenueStore,
    revenueStore: revenueStoreList,
  } = useRevenueStore();

  // search user group
  useEffect(() => {
    if (revenueStore?.data) {
      const filterItem = revenueStore?.data?.filter((item: any) =>
        item?.userGroup
          ?.toLowerCase()
          .includes(debouceSearchQuery.toLowerCase())
      );
      setFilteredData(filterItem);
    }
  }, [debouceSearchQuery, revenueStore?.data]);

  // search group name
  useEffect(() => {
    if (revenueStore?.data) {
      const filterItemGroupName = revenueStore?.data?.filter((item: any) =>
        item?.groupName
          ?.toLowerCase()
          .includes(debouceSearchQueryGroupName.toLowerCase())
      );
      setFilteredData(filterItemGroupName);
    }
  }, [debouceSearchQueryGroupName, revenueStore?.data]);

  const { end, start } = getStartEndOfCurrentMonth();

  useEffect(() => {
    if (startDate && endDate) {
      setStartDate(startDate);
      setEndDate(endDate);
      setAccountId(info?.id);
    } else {
      setStartDate(start);
      setEndDate(end);
      setAccountId(info?.id);
    }
  }, [start, end, info?.id]);

  useEffect(() => {
    setRevenueStore(revenueStore?.data);
  }, [startDate, endDate, revenueStore]);

  return (
    <>
      {isLoading ? (
        <LoaderCustom></LoaderCustom>
      ) : (
        <div className="">
          <div className="w-[100%] items-center md:pb-2 max-sm:mt-4 font-semibold text-ok-travel-green flex lg:pb-0 justify-between border-b-[1.5px] mb-2 md:mb-4">
            <div className="w-[100%] max-md:mt-4 items-center md:pb-2 font-semibold text-ok-travel-green flex pb-4 lg:pb-0 justify-between mb-2 md:mb-4">
              <h3 className="uppercase px-[16px] md:px-[0px] text-medium text-gray-500 md:text-md xl:text-xl">
                Manage Revenue Store
              </h3>
            </div>
            <div className="gap-4 lg:flex hidden">
              <div className="2xl:w-[20vw] xl:h-[4.4vh] md:h-[4vh] h-[3.8vh] font-normal text-gray-500 rounded-sm px-2 xl:w-[18vw] mb-2 lg:w-[16vw] flex items-center gap-2 border-1 border-gray-400 bg-white">
                <img
                  className="2xl:w-6 xl:w-5 w-4 max-md:w-3"
                  src={searchIcon}
                  alt="search"
                ></img>
                <input
                  className=" placeholder:text-sm placeholder:font-normal outline-none bg-transparent"
                  type="text"
                  placeholder="Search Store"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="2xl:w-[20vw] xl:h-[4.4vh] md:h-[4vh] h-[3.8vh] font-normal text-gray-500 rounded-sm px-2 xl:w-[18vw] mb-2 lg:w-[16vw] flex items-center gap-2 border-1 border-gray-400 bg-white">
                <img
                  className="2xl:w-6 xl:w-5 w-4 max-md:w-3"
                  src={searchIcon}
                  alt="search"
                ></img>
                <input
                  className=" placeholder:text-sm placeholder:font-normal outline-none bg-transparent"
                  type="text"
                  placeholder="Search Name"
                  value={searchQueryGroupName}
                  onChange={(e) => setSearchQueryGroupName(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="flex max-md:hidden xl:w-[30%] w-[36%] md:flex md:flex-row md:justify-between md:items-center">
            <div className="w-[100%] md:mb-4">
              <Dropdown
                overlay={
                  <RangeCalendar
                    onChange={(value) => {
                      setStartDate(
                        `${value.start.year}-${
                          value.start.month < 10
                            ? `0${value.start.month}`
                            : value.start.month
                        }-${
                          value.start.day < 10
                            ? `0${value.start.day}`
                            : value.start.day
                        }`
                      );

                      setEndDate(
                        `${value.end.year}-${
                          value.end.month < 10
                            ? `0${value.end.month}`
                            : value.end.month
                        }-${
                          value.end.day < 10
                            ? `0${value.end.day}`
                            : value.end.day
                        }`
                      );
                      setIsShowCalender(false);
                    }}
                    aria-label="Date (No Selection)"
                  />
                }
                trigger={["click"]}
              >
                <div className="flex max-sm:text-[12px] text-sm text-gray-400 gap-2 my-4 cursor-pointer justify-between lg:px-4 px-2 py-1 border-[1px] border-gray-300 rounded-full bg-white">
                  <span className="text-sm placeholder:text-sm">
                    {startDate && endDate
                      ? `from ${formatMonthDate(
                          startDate
                        )} to ${formatMonthDate(endDate)}`
                      : "Filter date"}
                  </span>
                  <ScheduleOutlined />
                </div>
              </Dropdown>
            </div>
          </div>

          {/* Mobile */}
          <div className="flex items-center md:hidden w-full sm:px-[20px] xl:px-[26px] px-[16px] gap-2">
            <div className="w-1/2">
              <Dropdown
                overlay={
                  <RangeCalendar
                    onChange={(value) => {
                      setStartDate(
                        `${value.start.year}-${
                          value.start.month < 10
                            ? `0${value.start.month}`
                            : value.start.month
                        }-${
                          value.start.day < 10
                            ? `0${value.start.day}`
                            : value.start.day
                        }`
                      );

                      setEndDate(
                        `${value.end.year}-${
                          value.end.month < 10
                            ? `0${value.end.month}`
                            : value.end.month
                        }-${
                          value.end.day < 10
                            ? `0${value.end.day}`
                            : value.end.day
                        }`
                      );
                    }}
                    aria-label="Date (No Selection)"
                  />
                }
                trigger={["click"]}
              >
                <div
                  // onClick={() => setIsShowCalender(!isShowCalender)}
                  className="flex max-sm:text-[12px] text-sm text-gray-400 gap-2 my-4 cursor-pointer justify-between lg:px-4 px-2 py-1 border-[1px] border-gray-300 rounded-full bg-white"
                >
                  <span className="text-xs">
                    {startDate && endDate
                      ? `from ${formatMonthDate(
                          startDate
                        )} to ${formatMonthDate(endDate)}`
                      : "Filter date"}
                  </span>
                </div>
              </Dropdown>
            </div>
            <div className="w-1/2 border-[1px] border-gray-300 sm:px-[12px] xl:px-[18px] px-[8px] bg-white rounded-full">
              <input
                className=" text-xs outline-none bg-transparent"
                type="text"
                placeholder="Search Store"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {revenueStoreList &&
              filteredData &&
              filteredData?.map((item: any, index: number) => {
                return (
                  <CardItemRevenueStore
                    key={index}
                    idx={index}
                    data={item}
                  ></CardItemRevenueStore>
                );
              })}
            {revenueStoreList?.length < 1 && (
              <div className="w-full h-full flex-col gap-2 flex max-lg:mt-20 justify-center items-center">
                <img
                  className="max-md:w-[12rem]"
                  alt="empty"
                  src={emptyIcon}
                ></img>
                <span className="text-gray-500">Select a store</span>
              </div>
            )}
          </div>
          <FooterFilterMobile isFilter={true}>
            {/* Mobile */}
            <div className="2xl:w-[20vw] w-full xl:h-[4.4vh] md:h-[4vh] h-[3.6vh] max-sm:h-[5vh] max-sm:rounded-md font-normal text-gray-500 rounded-sm px-2 xl:w-[18vw] mb-2 lg:w-[16vw] flex items-center gap-2 border-1 border-gray-400 bg-white">
              <img
                className="2xl:w-6 xl:w-5 w-4 max-md:w-3"
                src={searchIcon}
                alt="search"
              ></img>
              <input
                className=" placeholder:text-sm placeholder:font-normal outline-none bg-transparent"
                type="text"
                placeholder="Search Store"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="2xl:w-[20vw] w-full xl:h-[4.4vh] md:h-[4vh] h-[3.6vh]  max-sm:h-[5vh] max-sm:rounded-md font-normal text-gray-500 rounded-sm px-2 xl:w-[18vw] mb-2 lg:w-[16vw] flex items-center gap-2 border-1 border-gray-400 bg-white">
              <img
                className="2xl:w-6 xl:w-5 w-4 max-md:w-3"
                src={searchIcon}
                alt="search"
              ></img>
              <input
                className=" placeholder:text-sm placeholder:font-normal outline-none bg-transparent"
                type="text"
                placeholder="Search Name"
                value={searchQueryGroupName}
                onChange={(e) => setSearchQueryGroupName(e.target.value)}
              />
            </div>
            <div className="sm:w-[50%] md:hidden max-md:w-[100%]">
              <Dropdown
                overlay={
                  <RangeCalendar
                    className="fixed w-auto"
                    onChange={(value) => {
                      setStartDate(
                        `${value.start.year}-${
                          value.start.month < 10
                            ? `0${value.start.month}`
                            : value.start.month
                        }-${
                          value.start.day < 10
                            ? `0${value.start.day}`
                            : value.start.day
                        }`
                      );

                      setEndDate(
                        `${value.end.year}-${
                          value.end.month < 10
                            ? `0${value.end.month}`
                            : value.end.month
                        }-${
                          value.end.day < 10
                            ? `0${value.end.day}`
                            : value.end.day
                        }`
                      );
                      setIsShowCalender(false);
                      setOpenSort(false);
                    }}
                    aria-label="Date (No Selection)"
                  />
                }
                trigger={["click"]}
              >
                <div className="2xl:w-[20vw] w-full xl:h-[4.4vh] md:h-[4vh] h-[3.6vh]  max-sm:h-[5vh] max-sm:rounded-md font-normal text-gray-500 rounded-sm px-2 xl:w-[18vw] mb-2 lg:w-[16vw] flex items-center gap-2 border-1 border-gray-400 bg-white">
                  <ScheduleOutlined className="2xl:w-6 xl:w-5 w-4 max-md:w-3" />
                  <span className="text-[12px] text-gray-500 font-medium">
                    {startDate && endDate
                      ? `From ${formatMonthDate(
                          startDate
                        )} to ${formatMonthDate(endDate)}`
                      : "Filter date"}
                  </span>
                </div>
              </Dropdown>
            </div>
          </FooterFilterMobile>
        </div>
      )}
    </>
  );
};

export default RevenueStoreUserPage;
